import { useEffect } from 'react'
import { useTranslation } from 'react-i18next'

import { animate, motion, useMotionValue, useTransform } from 'motion/react'

import { formatValue } from './helpers'

const AnimatedNumber = ({ target, duration = 1, format, currency }) => {
  const { i18n } = useTranslation()
  const numericTarget = Number(target)
  const isValid = numericTarget >= 0
  const count = useMotionValue(0)
  const formatted = useTransform(count, latest => formatValue(latest, { format, currency, language: i18n.language }))

  useEffect(() => {
    if (!isValid) return

    count.set(0)
    const controls = animate(count, numericTarget, { duration })

    return () => controls.stop()
  }, [count, duration, numericTarget, isValid])

  if (!isValid) return '-'

  return <motion.span>{formatted}</motion.span>
}

export default AnimatedNumber
